export default {
    ["AUTH_REQUEST"]: (state) => {
        state.status = "loading";
    },
    ["AUTH_SUCCESS"]: (state, { token, account }) => {
        state.status = "success";
        state.token = token;
        state.name = account.nameY;
        state.site = account.site;
        state.familyID = account.id;
    },
    ["AUTH_LOGOUT"]: (state) => {
        state.status = "";
        state.token = "";
        state.name = "";
        state.site = "";
        state.familyID = "";
    },
    ["AUTH_ERROR"]: (state) => {
        state.status = "error";
    },
};
